import Backbone from 'backbone'
import template from './global-search.hbs'
import $ from 'jquery'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import conductor from 'scoreboard/components/conductor'
import selects from 'scoreboard/components/selects'
import metadata from 'scoreboard/components/metadata'
import icon from 'scoreboard/components/icon'
import mobile from 'scoreboard/components/mobile'
import KeyCodes from 'scoreboard/components/key-codes'
import sections from 'scoreboard/components/sections'
import SearchView from 'scoreboard/components/search-view'
import projects from 'scoreboard/projects/projects'
import constants from 'scoreboard/components/constants'
const { BORDER_WIDTH } = constants

let lastNavigatedTo
var GlobalSearch = SearchView.extend({

	className: 'dialog-body global-search-dialog',

	events: {
		'change .global-search': 'navigateTo'
	},

	initialize: function() {
		SearchView.prototype.initialize.apply(this, arguments)
		this._options = []
		_.bindAll(this, 'documentClick', 'resize')
	},

	render: function () {
		this.$el.empty().append(template())
		// #11761 wait a sec before registering the event or else if an unsaved
		// changes prompt was displayed, clicking on that will be registered as
		// clicking on the document and the global search will close itself
		// right away
		process.nextTick(function() {
			$(document).on('click', this.documentClick)
		}.bind(this))
		$('.the-dialog').has('.global-search').addClass('global-search-dialog')
		this.draw()

		// There are three cases where the .select-menu goes away and we will need
		// to resize the dialog because of that.
		// 1. When the window is resized (or screen orientation change on mobile)
		$(window).on('resize', this.resize)
		// 2. When a mousedown or touch occurs outside the global search control
		$('.dialog-holder').on('mousedown touchstart', function() {
			// Only resize when the .select-menu is gone in case the mousedown/touch
			// was performed on it
			if (this.$('.select-menu').length == 0) {
				this.resize()
			}
		}.bind(this))
		// 3. Escape key is pressed (Close the dialog)
		this.$('.global-search').on('keydown', (e) => {
			if (e.keyCode == KeyCodes.ESC) {
				this.resize() // Allows for a smooth transition when closing
				this.trigger('done')
			}
		})
		return this
	},

	draw: function (opts, itemAfter) {
		var self = this
		this._options = opts
		selects.filtering(this.$('select#global-search')[0], {
			accessors: { value: 'id' },
			groupBy: 'type',
			closeOnClick: false,
			placeholder: i18n.get('common.search'),
			attachToWrapper: true,
			autofocus: true,
			setDefaultOption: false,
			filter: () => opts, // We filtered on the server, return the options as we received them
			render: {
				itemBefore: function (d, input) {
					return icon('find', 'icon')
				},
				groupHeader: function (domainType, values) {
					// If the returned domainTypes don't match our svg names
					var icons = {
						'scorecard-item' : 'scorecard',
						'organization': 'circle-fill',
						'briefing': 'briefings',
						'slide': 'briefings',
						'file': 'document-blank'
					}
					var iconName = icons[domainType] || domainType

					return icon(iconName, 'icon') +
						'<span class="label">' + i18nTypeLabel(domainType) +
						' (' + values.length + ')' + '</span>'
				},
				option: (d, searchTerm) => {
					if (d.type === 'organization') {
						return this._projectOrgLabel(d.projectId, d.label)
					}
					return '<div class="name">' + selects.optionHtml(d, searchTerm) + '</div>' +
						'<div class="organization">' + this._projectOrgLabel(d.projectId, d.organizationLabel) + '</div>'
				},
				item: function (d, input) {
					return _.escape(d.label + ' (' + d.type + ')')
				},
				itemAfter: itemAfter
			},
			onSearch: function (value) {
				self.search(value)
				self.appendLoadingDots()
			},
			options: opts || []
		})

		if (!$('select#global-search').val()) {
			this.clearLoadingDots()
		}

		this.resize()
	},

	/**
	 * If projects are visible the org must be prefixed with the project label
	 */
	_projectOrgLabel(projectId, orgLabel) {
		let label = orgLabel
		if (projectId && projects.isVisible()) {
			const projectLabel = _.get(projects.get(projectId), 'attributes.label')
			// There should always be a project label, but let's play it safe
			label = projectLabel ? `${projectLabel}: ${label}` : label
		}
		return _.escape(label)
	},

	// Resize the dialog to fit the search bar (.select-control) and search menu (.select-menu)
	resize: function() {
		// After populating the .select-menu portion which contains the results,
		// we need to make sure the height of the entire dialog isn't taller than
		// it should be (at max, there should be the same spacing above as bellow the dialog)
		var bodyHeight = $('body').height()
		var surroundingSpace = 2*this.$el.offset().top
		var selectControl = this.$('.select-control')
		var selectMenu = this.$('.select-menu')
		// Clear existing height before setting it below
		this.$el.css('height', 'auto')
		// If there are results, set the overall size (1px extra for padding)
		if (selectMenu.length) {
			if (bodyHeight - this.$el.height() < surroundingSpace) {
				// If we've run out of vertical space, adjust the height to fit the body
				this.$el.css('height', bodyHeight - surroundingSpace + BORDER_WIDTH)
			} else {
				// If we have space, set the height (search box + results menu)
				this.$el.css('height', selectControl.height() + selectMenu.height() + BORDER_WIDTH)
			}
		}
	},

	navigateTo: function(e) {
		var targetResource = this._options[e.target.selectedIndex-1]
		if (targetResource) {
			var targetURL = createTargetURL(targetResource)
			this.trigger('done')
			if (targetResource.projectId) {
				projects.id = targetResource.projectId
			}
			lastNavigatedTo = createTargetContext(targetResource)
			conductor.navigate(targetURL, {trigger:true})

			// If we're opening a search result in the mobile orientation,
			// we should jump back to the display pane #10910
			if (mobile.isMobileWidth() || mobile.isMobileHeight()) {
				Backbone.trigger('mobile:toggle-mobile-menu', true)
			}
		}
	},

	documentClick: function(e) {
		var target = $(e.target)
		var outsideSearch = target.closest('.dialog-body-content').length === 0
		var notSearchEvent = !target.hasClass('global-search')
		// If no results show, there is still a container under the search box, but it is transparent
		var hiddenListClick = target.hasClass('select') && !target.hasClass('has-menu')

		if (outsideSearch && notSearchEvent || hiddenListClick) {
			this.trigger('done')
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		$(document).off('click', this.documentClick)
		$('.the-dialog').has('.global-search').removeClass('global-search-dialog')
		$(window).off('resize', this.resize)
	}

})

function i18nTypeLabel(type) {
	return  i18n.get(metadata[sections.fromType(type)].sectionCode)
}

/**
 * Given a search result, get the url to navigate to
 *
 * @param {object} targetResource
 * @param {string} currentPath for unit tests to inject a path for the conductor
 * @returns {string}
 */
function createTargetURL(targetResource, currentPath) {
	const {id, type, section} = createTargetContext(targetResource)
	var urlPrefix = sections.toUrl(section)
	var targetURL = urlPrefix + '/' + id

	if (type === 'organization') {
		let currentSection = conductor.section(currentPath)
		if (!currentSection || !metadata[currentSection].requiresOrg) {
			// We're coming from a section not associated to an org, so we have
			// to go to one that requires an org.
			currentSection = sections.default()
		}
		targetURL += '/' + sections.toUrl(currentSection)
	} else if (type === 'slide') {
		targetURL = urlPrefix + '/' + targetResource.briefingId
			+ '/slides/' + id
	}
	return targetURL
}

function createTargetContext(targetResource) {
	const {id, type} = targetResource
	const section = metadata[type].section
	return {
		id, type, section
	}
}

/**
 * Information about the resource that a user just navigated to
 * via global search.  Cleared the first time it's read.
 * @returns {id:Number, section:String}
 */
function getAndClearLastNavigatedTo() {
	let last = lastNavigatedTo
	lastNavigatedTo = undefined
	return last
}

_.extend(GlobalSearch, {
	getAndClearLastNavigatedTo,
	createTargetURL,
	i18nTypeLabel
})
export default GlobalSearch
export { getAndClearLastNavigatedTo }

//These are exposed for testing and not meant to be used publicly
export { createTargetURL }
export { i18nTypeLabel }

GlobalSearch.__filename__ = 'global-search/global-search.js'
